export default __webpack_public_path__ + "static/media/rookiewise.42364aa2.less";